module.exports = __webpack_public_path__ + "static/media/404.3aa78696.png";